
export default {
  required: value => !!value || 'Required.',
  required_voltage: value => !!value.voltage || 'Required.',
  counter: value => value.length <= 50 || 'Max 20 characters',
  max15: value => {
    if (value == null){
      return true;
    }
    return value.length <= 15 || 'Max 15 characters'
  },
  email: value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || 'Invalid e-mail.'
  },
  number: value => {
    return !isNaN(Number(value)) || "Please enter a number."
  },
  integer: value => {
    return parseInt(value, 10) > 0 || "Please enter a whole number."
  },
  positive: value => {
    return parseFloat(value) > 0 || "Please enter a positive number."
  }
}